import React from 'react';
import { Box, IconButton } from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import type { SxProps } from '@mui/material/styles';

type Props = {
  onBack: () => void;
  sx?: SxProps;
};

const CustomerUserHeader: React.FC<Props> = ({ onBack, sx }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        marginBottom: 1,
        justifyContent: 'flex-start',
        ...sx,
      }}
    >
      <IconButton
        onClick={onBack}
        size="small"
        aria-label="Back"
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 1,
          height: 40,
          px: 1.25,
          borderRadius: '12px',
          border: '1px solid',
          borderColor: 'divider',
          color: 'text.primary',
          backgroundColor: 'grey.50',
          '&:hover': { backgroundColor: 'grey.100' },
        }}
      >
        <ArrowBackIcon sx={{ fontSize: 22 }} />
        {/* MUI IconButton uses padding; ensure label is readable and not clipped */}
        <Box
          component="span"
          sx={{
            fontSize: 14,
            fontWeight: 600,
            lineHeight: 1,
            whiteSpace: 'nowrap',
            userSelect: 'none',
          }}
        >
          Back
        </Box>
      </IconButton>
    </Box>
  );
};

export default CustomerUserHeader;
